module.exports = __webpack_public_path__ + "images/a50e5ea9bb321a5e0fbecbfa5b8a6386.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations05.jpg
// module id = ./webpack/assets/img/wheels-locations05.jpg
// module chunks = 0